import {AbstractProdForm, ProdFormField, ProdFormFieldType, ProdFormValidators, RequiredValidator} from 'prod-form';
import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {HelpService} from "../../../services/help.service";
import {ProdDialogData} from 'prod-dialog';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-help-form',
  templateUrl: './help-form.html'
})
export class HelpForm extends AbstractProdForm {
  title: string = this.translate.instant('help.form.title');
  fields: ProdFormField[] = [
    ProdFormField.create({
      name: 'name',
      label: this.translate.instant('help.form.name'),
      type: ProdFormFieldType.TEXT,
      validators: new ProdFormValidators([
        new RequiredValidator(),
      ]),
    }),
    ProdFormField.create({
      name: 'language',
      label: this.translate.instant('help.form.language'),
      type: ProdFormFieldType.TEXT,
      validators: new ProdFormValidators([
        new RequiredValidator(),
      ]),
    }),
    ProdFormField.create({
      name: 'file',
      label: this.translate.instant('help.form.file'),
      type: ProdFormFieldType.FILE_UPLOAD,
      isEditable: false,
      validators: new ProdFormValidators([
        new RequiredValidator(),
      ]),
    }),
  ];

  constructor(dialogRef: MatDialogRef<HelpForm>,
              @Inject(MAT_DIALOG_DATA) public dialogData: ProdDialogData,
              override dataService: HelpService,
              private translate: TranslateService) {
    super();
  }
}
